import React, { ReactElement, ReactNode } from "react";
import Colors from "../colors";
import Icon from "../Icon";
import styles from "./radio.module.css";
import { FlexRow } from "../Layout/Flex";
import { Typography } from "../Typography";

interface RadioProps {
  children: ReactNode;
  onPress?: () => void;
  active?: boolean;
  hideCircle?: boolean;
  testId?: string;
}

const Radio = ({
  children,
  active,
  onPress,
  hideCircle,
  testId,
}: RadioProps): ReactElement => {
  return (
    <button data-test-id={testId} onClick={onPress} className={styles.btn}>
      <FlexRow alignItems="center">
        <div className={styles.left}>
          <Typography align="left" color="black">
            {children}
          </Typography>
        </div>
        {!hideCircle && (
          <div className={styles.right}>
            {active ? (
              <Icon name="checkmark_circle" color={Colors.blue300} size={24} />
            ) : (
              <div className={styles.inActive} />
            )}
          </div>
        )}
      </FlexRow>
    </button>
  );
};
Radio.defaultProps = {
  active: false,
  style: undefined,
  width: undefined,
  hideCircle: false,
  onPress: () => {},
};

export default Radio;
